import React from 'react';
import Tooltip from './Tooltip';
import StudentTransferButton from './StudentTransferButton';
import { Student } from '../types';
interface StudentTooltipProps {
  students: Student[];
  position?: 'top' | 'right' | 'bottom' | 'left';
  classroomId: string;
}

const StudentTooltip: React.FC<StudentTooltipProps> = ({ 
  students, 
  position = 'bottom',
  classroomId
}) => {
  const renderStudentTooltipContent = () => (
    <div className="tooltip-section">
      <div className="tooltip-section-title">
        <div className="student-name-with-icon">
          <span className="student-name-text">Students ({students.length})</span>
          {students.length > 0 && (
            <StudentTransferButton
              students={students}
              currentClassroomId={classroomId}
            />
          )}
        </div>
      </div>
      {students.length > 0 ? (
        <ul className="tooltip-name-list">
          {students.map((student, index) => (
            <li key={index} className="tooltip-name-item">
              <div className="student-name-with-icon">
                <span className="student-name-text">{student.name}</span>
                {student.id && (
                  <StudentTransferButton
                    students={[student]}
                    currentClassroomId={classroomId}
                  />
                )}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="tooltip-empty">No students checked in</div>
      )}
    </div>
  );

  return (
    <div className="student-tooltip-component">
      <Tooltip content={renderStudentTooltipContent()} position={position}>
        <span className="count-with-tooltip">{students.length}</span>
      </Tooltip>
    </div>
  );
};

export default StudentTooltip;
